<template>
  <div>
    <div id="progressbar">
      <div :style="`width: ${progressByPercent}`"></div>
    </div>
    <i
      class="fas fa-times closing pointer exit-zen-mode"
      @click="exitCardsView"
    />
    <van-loading
      v-if="Object.keys(box.data).length == 0"
      size="24px"
      vertical
      class="loading"
    >
      {{ $t("loading") }}...
    </van-loading>
    <div v-else-if="box.data && box.data.cards && box.data.cards.length > 0">
      <template v-if="!done">
        <template v-for="(card, index) in cards">
          <Question
            :key="`${index}-${card.id}`"
            :card="card"
            v-if="currentCardIndex == index"
            :selections="getAnswerSelections(card.back_word)"
            :testByFrontWord="true"
            @submit="submit"
          />
        </template>
      </template>
      <template v-else>
        <div class="done">
          <h1>{{ box.data.name }}</h1>
          <div class="donut-box">
            <DonutChart
              :height="200"
              :fontSize="3"
              :top="35"
              :percent="(this.correctCount * 100) / cards.length"
            />

            <h3 class="donut-box-text">
              <span v-if="(this.correctCount * 100) / cards.length > 90">
                💥💥💥
              </span>
              <span v-else-if="(this.correctCount * 100) / cards.length > 80">
                💥💥
              </span>
              <span v-else-if="(this.correctCount * 100) / cards.length > 70">
                💥
              </span>
              {{ $t("all done!") }}
            </h3>
          </div>
          <router-link
            class="btn"
            style="color: white; width:320px; text-align:center;border-radius:5px;"
            :to="{ name: 'interim-box', params: { id: $route.params.id } }"
          >
            {{ $t("next") }}
          </router-link>
          <div class="statBoxes">
            <div class="statBox" style="color:green;">
              <h1 class="statBoxNum">{{ correctCount }}</h1>
              <h3><i class="fas fa-spell-check"></i>{{ $t("correct") }}</h3>
            </div>
            <div class="statBox" style="color:red;">
              <h1 class="statBoxNum">{{ cards.length - correctCount }}</h1>
              <h3><i class="fas fa-times-circle"></i>{{ $t("mistakes") }}</h3>
            </div>
          </div>
        </div>
      </template>
    </div>
    <van-empty
      v-else
      image="error"
      :description="$t('no cards')"
      class="empty"
    />
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { mapActions, mapMutations } from "vuex";
import Question from "@/components/Question";
import DonutChart from "@/components/chart/DonutChart";
import zenModeRequired from "@/mixins/zenModeRequired";
export default {
  name: "BoxQuiz",
  mixins: [zenModeRequired],
  components: { Question, DonutChart },
  computed: {
    ...mapState("vokabel", ["box"]),
    ...mapGetters("vokabel", ["canEditBox", "cards"]),
    progressByPercent() {
      let percent = 0;
      percent = (this.currentCardIndex * 100) / this.cards.length;
      return `${percent}%`;
    },
    possibleFrontWords() {
      const { cards } = this;
      if (cards && cards.length > 0) {
        return this.possibleWords(cards, "front_word");
      }
      return [];
    },
    possibleBackWords() {
      const { cards } = this;
      if (cards && cards.length > 0) {
        return this.possibleWords(cards, "back_word");
      }
      return [];
    }
  },
  data() {
    return {
      correctCount: 0,
      currentCardIndex: 0,
      done: false
    };
  },
  methods: {
    ...mapActions("vokabel", [
      "submitQuizResult",
      "getQuizInformation",
      "addToFavBox",
      "updateSeenStat"
    ]),
    ...mapMutations("setting", ["CLOSE_ZEN_MODE", "SET_BACK_ROUTE"]),
    ...mapActions("setting", ["navigateBack"]),
    exitCardsView() {
      this.navigateBack();
      this.CLOSE_ZEN_MODE();
    },
    possibleWords(cards, key) {
      let seen = {};
      return cards.reduce((accu, item) => {
        const { word, id, image } = item[key];
        const wordLowerCase = word.toLowerCase();
        if (!(wordLowerCase in seen)) {
          accu.push({ word, id, image });
          seen[wordLowerCase] = true;
        }
        return accu;
      }, []);
    },
    getRandomInt(max) {
      return Math.floor(Math.random() * Math.floor(max));
    },
    getAnswerSelections(answer) {
      let maxChoices = 4;
      const { possibleBackWords, getRandomInt } = this;
      const selections = [];
      let randomWord = ["auf", "mit", "durch", "vor"];
      randomWord = randomWord.map((word, id) => ({ word, id }));
      let all = possibleBackWords.concat(randomWord);
      const maxLength = all.length;
      while (selections.length < maxChoices) {
        const index = getRandomInt(maxLength);
        let answerWord = all[index];
        const isDupAnswer = selections.some(
          item => item.word.toLowerCase() == answerWord.word.toLowerCase()
        );
        if (
          isDupAnswer ||
          answerWord.word == "" ||
          answerWord.word == answer.word
        ) {
          continue;
        }
        selections.push(answerWord);
      }
      const correctIndex = getRandomInt(maxChoices);
      selections[correctIndex] = answer;
      return selections;
    },
    submit(correct) {
      const { cards, currentCardIndex } = this;
      let postData = { box: this.$route.params.id };

      if (correct) {
        this.$notify({
          group: "quiz",
          type: "success",
          title: this.$t("correct")
        });
        postData["yes_or_no"] = true;
        this.correctCount = this.correctCount + 1;
      } else {
        this.$notify({
          group: "quiz",
          type: "error",
          title: this.$t("wrong")
        });
        postData["yes_or_no"] = false;
      }
      this.updateSeenStat({
        postData,
        id: cards[currentCardIndex].front_word.id
      });
      this.currentCardIndex = this.currentCardIndex + 1;
      if (this.currentCardIndex == this.cards.length) {
        this.done = true;
        this.submitQuizResult({
          box: this.$route.params.id,
          data: { score: (this.correctCount * 100) / cards.length }
        });
      }
    }
  },
  created() {
    this.getQuizInformation(this.$route.params.id);
    this.SET_BACK_ROUTE({
      name: "interim-box",
      params: {
        id: this.$route.params.id
      }
    });
  }
};
</script>

<style lang="scss">
@import "@/assets/styles.scss";
$font-size-huge: 1rem;
#progressbar {
  background-color: #f1f1f1;
  border-radius: 10px;
  padding: 1px;
  margin-top: 3px;
  margin-left: 20px;
  margin-right: 10px;
}

#progressbar > div {
  background-color: #a3e08f;
  height: 10px;
  border-radius: 10px;
}

.done {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 75vh;
  position: relative;
  top: 300px;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
}
.statBoxes {
  display: flex;
  > .statBox {
    text-align: center;
    border: 1px solid #e3e3e3;
    padding: 20px;
    width: 150px;
    margin: 10px;
  }
  .statBoxNum {
    color: #2f2f2f;
    font-size: 2.3rem;
    font-weight: bold;
  }
}
.donut-box {
  border: 1px solid #e3e3e3;
  border-radius: 5px;
  padding: 57px;
  margin-bottom: 30px;
  position: relative;
  .donut-box-text {
    position: absolute;
    bottom: 10px;
  }
}
</style>
